module.exports = __webpack_public_path__ + "static/img/slide-arrow-right.b0dc2010.svg";